<template>
  <v-div class="SelectedEvents">
    <v-div
      v-if="title"
      :title="showLargeTitle"
      :font-weight-bold="showLargeTitle"
      pb-2
      text-primary
      border-bottom-primary-thick
    >
      <h2 v-if="displayIsMobile" class="title font-weight-bold">
        <button
          :aria-expanded="`${showDetails}`"
          @click.prevent="onToggleDisplay"
        >
          Latest Events
          <v-icon color="primary" class="mt-1">{{
            showDetails ? mdiChevronUp : mdiChevronDown
          }}</v-icon>
        </button>
      </h2>
      <h2 v-else class="title font-weight-bold">Latest Events</h2>
    </v-div>
    <h2 v-else class="d-sr-only">Latest Events</h2>
    <ContainerGrid>
      <LayoutItems
        v-if="showDetails"
        :items="events"
        component-name="EventSummary"
        cols="12"
        sm="6"
        md="6"
        lg="4"
      />
    </ContainerGrid>
  </v-div>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from "@mdi/js";
import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

export default {
  name: "SelectedEvents",
  components: {
    ContainerGrid,
    LayoutItems,
  },
  props: {
    title: { type: String, default: undefined },
    events: { type: Array, default: () => [] },
    showLargeTitle: { type: Boolean, default: true },
  },
  data() {
    return {
      showDetails: true,
      // Icons
      mdiChevronDown,
      mdiChevronUp,
    };
  },
  computed: {
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
  },
  methods: {
    onToggleDisplay() {
      this.showDetails = !this.showDetails;
    },
  },
};
</script>

<style>
.SelectedEvents h2 button {
  width: 100%;
  text-align: left;
}

.SelectedEvents h2 button i {
  float: right;
}
</style>
